import '@mantine/core/styles.css';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import MainPage from './MainPage/MainPage';
import { MantineProvider, createTheme } from '@mantine/core';
import { QueryClient, QueryClientProvider } from 'react-query';

// Sharp corners + the existing brand blue, applied to all Mantine-native
// components (inputs, selects, modals) for a consistent industrial look.
const theme = createTheme({
    defaultRadius: 'xs',
    primaryColor: 'brand',
    primaryShade: 6,
    colors: {
        brand: [
            '#E9F6FC', // 0 (accent)
            '#D0ECF8', // 1
            '#A6DBF1', // 2
            '#79C8E9', // 3
            '#55B8E4', // 4
            '#3DAFE1', // 5
            '#30A9E0', // 6 (primary)
            '#1A8BBB', // 7 (hover)
            '#136F97', // 8
            '#0B5372', // 9
        ],
    },
});

function App() {
    return (
        <MantineProvider theme={theme} withGlobalStyles withNormalizeCSS>
            <QueryClientProvider client={new QueryClient()}>
                <Router>
                    <Routes>
                        <Route path="/" element={<MainPage />} />
                        {/* Any unknown path falls back to the main page. */}
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </Router>
            </QueryClientProvider>
        </MantineProvider>
    );
}

export default App;


